// extracted by mini-css-extract-plugin
module.exports = {"container":"RepoCard_container__1LlxO","header":"RepoCard_header__1ruN9","content":"RepoCard_content__v1fMh","footer":"RepoCard_footer__3_As-"};